import React from 'react';
import './Dashboard.css';
import RTUpbitChart from '../features/RTUpbitChart';
import RTUpbitChartBTC from '../features/RTUpbitChartBTC';
import RTUpbitChartETH from '../features/RTUpbitChartETH';
import RTUpbitChartSOL from '../features/RTUpbitChartSOL';
import RTUpbitChartAAVE from '../features/RTUpbitChartAAVE';
import RTUpbitChartXRP from '../features/RTUpbitChartXRP';
import RTUpbitChartLINK from '../features/RTUpbitChartLINK';
import RTUpbitChartENS from '../features/RTUpbitChartENS';
import BTCoinBacktest from '../features/BTCoinBacktest';
import BTCoinBacktestMock from '../features/BTCoinBacktestMock';
import CoinArchitecture from '../components/CoinArchitecture';
import TradeCoin from '../features/TradeCoin';

const CoinDashboard: React.FC = () => {

  return (
    <div className="dashboard-page">
      <div className="dashboard-sections">
        {/* 아키텍처 다이어그램 섹션 */}
        <div className="dashboard-section">
          <div className="section-header">
            <h2>시스템 아키텍처</h2>
          </div>
          <div className="section-content">
            <CoinArchitecture />
          </div>
        </div>

        {/* 실시간 Upbit 차트 섹션 */}
        <div className="dashboard-section">
          <div className="section-header">
            <h2>실시간 Upbit 차트</h2>
          </div>
          <div className="section-content">
            <RTUpbitChart />
          </div>
        </div>

        {/* 실시간 Upbit 차트 (KRW-BTC) 섹션 */}
        <div className="dashboard-section">
          <div className="section-header">
            <h2>실시간 Upbit 차트 (KRW-BTC)</h2>
          </div>
          <div className="section-content">
            <RTUpbitChartBTC />
          </div>
        </div>

        {/* 실시간 Upbit 차트 (KRW-ETH) 섹션 */}
        <div className="dashboard-section">
          <div className="section-header">
            <h2>실시간 Upbit 차트 (KRW-ETH)</h2>
          </div>
          <div className="section-content">
            <RTUpbitChartETH />
          </div>
        </div>

        {/* 실시간 Upbit 차트 (KRW-SOL) 섹션 */}
        <div className="dashboard-section">
          <div className="section-header">
            <h2>실시간 Upbit 차트 (KRW-SOL)</h2>
          </div>
          <div className="section-content">
            <RTUpbitChartSOL />
          </div>
        </div>

        {/* 실시간 Upbit 차트 (KRW-AAVE) 섹션 */}
        <div className="dashboard-section">
          <div className="section-header">
            <h2>실시간 Upbit 차트 (KRW-AAVE)</h2>
          </div>
          <div className="section-content">
            <RTUpbitChartAAVE />
          </div>
        </div>

        {/* 실시간 Upbit 차트 (KRW-XRP) 섹션 */}
        <div className="dashboard-section">
          <div className="section-header">
            <h2>실시간 Upbit 차트 (KRW-XRP)</h2>
          </div>
          <div className="section-content">
            <RTUpbitChartXRP />
          </div>
        </div>

        {/* 실시간 Upbit 차트 (KRW-LINK) 섹션 */}
        <div className="dashboard-section">
          <div className="section-header">
            <h2>실시간 Upbit 차트 (KRW-LINK)</h2>
          </div>
          <div className="section-content">
            <RTUpbitChartLINK />
          </div>
        </div>

        {/* 실시간 Upbit 차트 (KRW-ENS) 섹션 */}
        <div className="dashboard-section">
          <div className="section-header">
            <h2>실시간 Upbit 차트 (KRW-ENS)</h2>
          </div>
          <div className="section-content">
            <RTUpbitChartENS />
          </div>
        </div>

        {/* 코인 백테스트 섹션 */}
        <div className="dashboard-section">
          <div className="section-header">
            <h2>코인 백테스트</h2>
          </div>
          <div className="section-content">
            <BTCoinBacktest />
          </div>
        </div>

        {/* 코인 백테스트 (Mock) 섹션 */}
        <div className="dashboard-section">
          <div className="section-header">
            <h2>코인 백테스트 (Mock)</h2>
          </div>
          <div className="section-content">
            <BTCoinBacktestMock />
          </div>
        </div>

        {/* Trade Coin 섹션 */}
        <div className="dashboard-section">
          <div className="section-header">
            <h2>코인 거래 데이터</h2>
            <p style={{ fontSize: '12px', color: '#888', marginTop: '4px' }}>
              {process.env.REACT_APP_ENV === 'mercury-frontend-prod' 
                ? '프로덕션: trade_coin 테이블' 
                : '개발: trade_coin_bt 테이블'}
            </p>
          </div>
          <div className="section-content">
            <TradeCoin />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoinDashboard;

